var map;
var styles = [
    {
        stylers: [
            { hue: "#0d1622" },
            { saturation: -20 }
        ]
    },{
        featureType: "road",
        elementType: "geometry",
        stylers: [
            { lightness: 100 },
            { visibility: "simplified" }
        ]
    }
];
function initMap() {
    map = new google.maps.Map(document.getElementById('map_canvas'), {
        center: {lat: 37.101542, lng: 27.2995339},
        zoom: 17,
        styles: styles,
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: true
    });

    var iconBase = '/wp-content/themes/pilatesunlimited/assets/images/marker.png';
    var marker = new google.maps.Marker({
        position: {lat: 37.101542, lng: 27.2995339},
        map: map,
        icon: iconBase
    });
}